import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import { EMAIL_REGEX } from '../../Constants';
import { SkywatchDialog } from '../PopUps/SkywatchDialog';
import FlexView from 'react-flexview/lib';
import NewFillButton from '../Core/NewFillButton';
import { ElevatedCircle } from '../Core/ElevatedCircle';
import policymanagementApi from '../../api/policymanagement.api';
import { addDays, awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { PolicyManagementContextStore, ACTIONS } from '../../context/PolicyManagementContext';
import { Action } from '../../models/Action';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel';
import { RadioGroup, Radio, FormControlLabel,Select, MenuItem } from '@material-ui/core';
import { AdditionalInsuredPolicyView } from '../AdditionalInsured/AdditionalInsuredPolicyView';
import policmanagementImpersonationApi from '../../api/policmanagement.impersonation.api';

export const GenerateEndorsementPopup = ({open, insuranceId, onCancel, ...props}) => {
  const { register, errors, getValues, triggerValidation, control } = useForm()
  const context = React.useContext(PolicyManagementContextStore)

  const insurance: ActiveInsuranceModel = context.getInsurance(insuranceId)

  const handleClose = () => {
    onCancel && onCancel()
  };

  const Confirm = async () => {
      let valid = await triggerValidation()

      if(!valid) return;

      let res = await awaitWithLoading(policmanagementImpersonationApi.generateAdditionalEndorsement(insuranceId,
        context.activeAdditionalInsuredList[Number.parseInt(getValues()['aiIndex'])].id, getValues()['endorsement_wording'],));

      if(res.ok) { 
        EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Success',
             body: 'The endorsement was generated successfully!',
             actionText: "View Endorsement",
             onClose: (val) => val == 1 && window.open(res.data.url_endoesement ,'_blank'),
        })
      }
      else {
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }

      handleClose()
  }
  return (
      <SkywatchDialog
        open={open}
        closeDialog={handleClose}
        maxWidth={'xs'}
        circleHeader={<ElevatedCircle> <AssignmentIcon className="blue" /> </ElevatedCircle>}
        closeTitle={"Your Policy"}>
        <FlexView column>
          <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">Generate Additional Insured Endorsement</div>
          {context.activeAdditionalInsuredList.length == 0 ? <>
            <div className="text-body textcenter red">You should add an additional insured before generating an endorsement</div>
            <br />
           </> : <>
            <Controller control={control} 
                    name="aiIndex" 
                    defaultValue={"0"}
                    as={
                    <RadioGroup>
                        {context.activeAdditionalInsuredList.map((ai, index) => <FlexView vAlignContent={'center'} key={index}>
                            <FormControlLabel value={index.toString()} className="margin-top-basic" control={<Radio color='primary' />} />
                            <AdditionalInsuredPolicyView ai={ai} />
                        </FlexView>)}
                    </RadioGroup> } />
            <br />
            <TextField 
                    error={!!errors.endorsement_wording}
                    multiline
                    type="text" 
                    label="Additional Wording" 
                    helperText="Insert the additional wording you would like to add to the endorsement"
                    fullWidth
                    variant="outlined"
                    name="endorsement_wording" 
                    inputRef={register}  />
            </>}
            <NewFillButton disabled={context.activeAdditionalInsuredList.length == 0} onClick={Confirm}>Generate Endorsement</NewFillButton>
            {context.activeAdditionalInsuredList.length == 0 && <br />}
            <div onClick={handleClose} className="margin-bottom-basic text-body textcenter gray underline clickable">Close</div>
        </FlexView>
      </SkywatchDialog>
  );
}